export const MIN_ADDITION_DATE = new Date('2022-11-01T08:00:00.468Z');
export const MIN_ADDITION_REPORT_DATE = new Date('2022-01-01T08:00:00.468Z');